import { render } from "./seventeenPage.vue?vue&type=template&id=dfc74a8a&scoped=true"
import script from "./seventeenPage.vue?vue&type=script&lang=js"
export * from "./seventeenPage.vue?vue&type=script&lang=js"

import "./seventeenPage.vue?vue&type=style&index=0&id=dfc74a8a&lang=less&scoped=true"

import exportComponent from "/home/jenkins_home/workspace/c1-02_dwart2.0-apkpc-site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dfc74a8a"]])

export default __exports__